<template>
  <div class="modal fade" id="modalNpsCollaborator" role="dialog">
    <div class="modal-dialog modal-dialog-35" v-bind:style="{'width': width}">
      <!-- Modal content-->
      <div class="modal-content modal-nps-collaborator modal-global">
        <div class="modal-header">
          <button type="button" class="close" @click="closeModal()" data-dismiss="modal">&times;</button>
          <span>Queremos ouvir sua opinião :)</span>
        </div>
        <div class="modal-body">
          <span class="body-title">
            De 0 a 10, como você avalia o sistema da MarQ?
          </span>
          <div class="body-class">
            <div class="class-group">
              <span @click="selected(0)" id="btnClass0" class="btn-class danger">0</span>
              <span @click="selected(1)" id="btnClass1" class="btn-class danger">1</span>
              <span @click="selected(2)" id="btnClass2" class="btn-class danger">2</span>
              <span @click="selected(3)" id="btnClass3" class="btn-class danger">3</span>
              <span @click="selected(4)" id="btnClass4" class="btn-class danger">4</span>
              <span @click="selected(5)" id="btnClass5" class="btn-class danger">5</span>
              <span @click="selected(6)" id="btnClass6" class="btn-class danger">6</span>
              <span @click="selected(7)" id="btnClass7" class="btn-class warning">7</span>
              <span @click="selected(8)" id="btnClass8" class="btn-class warning">8</span>
              <span @click="selected(9)" id="btnClass9" class="btn-class success">9</span>
              <span @click="selected(10)" id="btnClass10" class="btn-class success">10</span>
            </div>
            <div class="class-description">
              <span class="danger">Não gosto</span>
              <span class="success">Gosto muito</span>
            </div>
            <div class="description-box">
              <span class="box-title">Você tem alguma sugestão para gente?</span>
              <textarea v-model="valueSuggestion" placeholder="Digite aqui" maxlength="244"/>
              <span class="box-lenght">{{ valueSuggestion.length }} / 244</span>
            </div>
            <div class="class-btn">
              <span @click="postponeNps()" class="btn-after">Responder depois</span>
              <button @click="registerNps()" class="btn-submit" :disabled="validateNps || loadingBtn">
                <div v-if="!loadingBtn" class="btn-default">
                  Enviar resposta
                  <ion-icon name="chevron-forward-outline"></ion-icon>
                </div>
                <div v-else class="loading-btn">
                  <div class="spinner-btn">
                    <div class="rect1"></div>
                    <div class="rect2"></div>
                    <div class="rect3"></div>
                    <div class="rect4"></div>
                    <div class="rect5">
                    </div>
                  </div>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {REQUEST_SERVICE} from "../../../requestConfig";
import {POSTPONE_NPS_USER, REGISTER_NPS_USER,} from "../../../urlConfig";
import {UTIL_SERVICE} from "../../../utils";

export default {
  name: "modal-nps-collaborator",
  props: {

  },
  data() {
    return {
      width: '100%',
      npsStatus: '',
      valueNpsSelected: '',
      valueSuggestion: '',
      validateNps: true,
      loadingBtn: false,
    }
  },
  methods: {
    closeModal() {
      $('#modalNpsCollaborator').modal('hide');
    },
    selected(value) {
      $('.btn-class').removeClass('selected')
      $('#btnClass' + value).addClass('selected')

      this.validateNps = false;
      this.valueNpsSelected = value;

      const idSelected = '#btnClass' + value;
      const removeClassSelected = function () {
        $('.btn-class').removeClass('selectedDanger')
        $('.btn-class').removeClass('selectedWarning')
        $('.btn-class').removeClass('selectedSuccess')
      }

      switch (idSelected) {
        case '#btnClass0':
        case '#btnClass1':
        case '#btnClass2':
        case '#btnClass3':
        case '#btnClass4':
        case '#btnClass5':
        case '#btnClass6':
          removeClassSelected()
          $('.selected').addClass('selectedDanger')
          break

        case '#btnClass7':
        case '#btnClass8':
          removeClassSelected()
          $('.selected').addClass('selectedWarning')
          break

        case '#btnClass9':
        case '#btnClass10':
          removeClassSelected()
          $('.selected').addClass('selectedSuccess')
          break
      }
    },
    postponeNps() {
      REQUEST_SERVICE.get(POSTPONE_NPS_USER)
        .then((response) => {
          UTIL_SERVICE.console("RESULT POSTPONE_NPS_USER:", response.data);
          this.closeModal();
        }).catch(reason => {
        UTIL_SERVICE.console("RESULT ERROR:", reason.data);
      });
    },
    registerNps() {
      this.loadingBtn = true

      let userLocal = JSON.parse(window.localStorage.getItem('userInfo'))
      let obj = {
        userId: userLocal.id,
        companyId: userLocal.companyId,
        userNpsStage: 1,
        deviceType: 3,
        message: this.valueSuggestion,
      }

      if (this.valueNpsSelected) {
        obj.rating = this.valueNpsSelected
      }

      UTIL_SERVICE.console("RESULT OBJ:", obj);
      REQUEST_SERVICE.post(REGISTER_NPS_USER, obj)
        .then((response) => {
          UTIL_SERVICE.console("RESULT REGISTER_NPS_USER:", response.data);
          swal('Sucesso!', response.data, 'success')
          this.loadingBtn = false;
          this.closeModal();
        }).catch(reason => {
        UTIL_SERVICE.console("RESULT ERROR:", reason.data);
        this.loadingBtn = false;
      });
    },
  }
}
</script>

<style lang="scss" scoped>

.modal-dialog {
  max-width: 500px;

  @media only screen and (max-width: 520px) {
    max-width: 96%;
    min-width: 96%;
  }
}

.modal-nps-collaborator {
  padding: 30px;
  box-shadow: none;
  border: none;
  border-radius: 8px;

  .modal-header {
    padding: 0 0 12px 0;
    border-bottom: 1px solid var(--bodyColor);

    .close {
      top: 10px;
      right: 10px;
    }

    span {
      color: var(--textActiveSide);
      font-size: 24px;
      font-weight: 700;
      line-height: 29.3px;
    }
  }

  .modal-body {
    padding: 12px 0 0 0;

    .body-title {
      color: var(--textSide);
      font-size: 14px;
      font-weight: 400;
      line-height: 19.7px;
    }

    .body-class {
      .class-group {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 16px;
        position: relative;

        .btn-class {
          display: flex;
          align-items: center;
          align-content: center;

          font-size: 14px;
          font-weight: 400;
          line-height: 19.73px;
          width: 36px;
          height: 40px;
          flex-direction: row;
          justify-content: space-around;
          border-radius: 4.31px;
          cursor: pointer;
          transition: .2s;
        }

        .danger {
          border: 1px solid var(--redColor);
          color: var(--redColor);

          &:hover {
            background-color: var(--redColor);
            color: #FFFFFF;
          }
        }

        .warning {
          border: 1px solid var(--yellowColor);
          color: var(--yellowColor);

          &:hover {
            background-color: var(--yellowColor);
            color: #FFFFFF;
          }
        }

        .success {
          border: 1px solid var(--lightGreen);
          color: var(--lightGreen);

          &:hover {
            background-color: var(--lightGreen);
            color: #FFFFFF;
          }
        }

        .selected {
          color: #FFFFFF;
        }

        .selectedDanger {
          background-color: var(--redColor) !important;
        }

        .selectedWarning {
          background-color: var(--yellowColor) !important;
        }

        .selectedSuccess {
          background-color: var(--lightGreen) !important;
        }
      }

      .class-description {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 6px;

        span {
          font-size: 13px;
          font-weight: 400;
          line-height: 18.28px;
        }

        .danger {
          color: var(--redColor);
        }

        .success {
          color: var(--lightGreen);
        }
      }

      .description-box {
        margin-top: 16px;
        position: relative;
        padding-bottom: 32px;

        .box-title {
          font-size: 14px;
          font-weight: 400;
          color: var(--textSide);
          line-height: 19.69px;
          margin-bottom: 3px;
        }

        textarea {
          background-color: var(--bodyColor) !important;
          width: 100%;
          max-width: 100%;
          min-width: 100%;
          min-height: 70px;
          max-height: 70px;
          font-size: 16px;
          font-weight: 400;
          line-height: 22.5px;
          color: var(--textSide);
          padding: 6px 12px;

          &::placeholder {
            font-size: 16px;
            font-weight: 400;
            line-height: 22.5px;
            color: var(--textSide);
          }
        }

        .box-lenght {
          font-size: 13px;
          font-weight: 400;
          line-height: 18.28px;
          color: var(--defaultText);
          position: absolute;
          bottom: 15px;
          right: 0;
        }
      }

      .class-btn {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        .btn-after {
          font-size: 14px;
          font-weight: 400;
          line-height: 19.69px;
          color: var(--linkColor);
          cursor: pointer;
          transition: .2s;

          &:hover {
            color: #7167ff;
          }
        }

        .btn-submit {
          display: flex;
          flex-direction: row;
          align-items: center;
          padding: 8px 19px;
          border-radius: 4px;
          border: none;
          cursor: pointer;
          transition: .2s;
          background: var(--linkColor);

          &:hover {
            background: #2c2588;
          }

          &:disabled {
            background: var(--defaultText);
            cursor: no-drop;

            &:hover {
              background: #6b7380;
            }
          }

          .btn-default {
            display: flex;
            align-items: center;
            flex-direction: row;
            font-size: 14px;
            font-weight: 400;
            line-height: 19.69px;
            color: #FFFFFF;
            background: transparent;

            ion-icon {
              font-size: 18px;
              margin-left: 3px;
            }
          }

          .loading-btn {
            width: 128.36px;
            height: 19.69px;
          }
        }
      }

      .validateError {
        position: absolute;
        right: 0;
        top: -18px;
        color: #D8152F;
        font-size: 12px;
        font-weight: 400;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/vue/views/modals/modalNpsCollaborator.vue